export default {
	project_name: 'Plateforme de Formation Grupo Boticário',
}
